import Vue from 'vue';
import store from '@/store';

interface State {
  size: {
    w: number;
    h: number;
  };
  modal: { [key: string]: boolean };
  modalData: { [key: string]: any };
  isFixed: boolean;
}

const state: State = {
  size: {
    w: window.innerWidth,
    h: window.innerHeight
  },
  modal: {
    phoneRegister: false,
    registration: false,
    successRegister: false,
    youtubeVideo: false,
    basketModal: false,
    messengerModal: false
  },
  modalData: {
    youtubeVideo: {}
  },
  isFixed: false
};

// getters
const getters = {
  size: (state: State) => state.size,
  modal: (state: State) => state.modal,
  modalData: (state: State) => state.modalData
};

// actions
const actions = {};

// mutations
const mutations = {
  SET_RESIZE(state: State, size: { w: number; h: number }) {
    state.size = size;
  },
  SET_FIXED_STATUS(state: State, status: boolean) {
    let html = document.querySelector('html');
    if (html) {
      if (status) {
        html.classList.add('hide');
      } else {
        html.classList.remove('hide');
      }
    }

    state.isFixed = status;
  },
  MODAL_OPEN(state: State, key: string) {
    Vue.set(state.modal, key, true);
    let isSome = Object.keys(state.modal).some((key) => state.modal[key]);
    if (isSome) {
      store.commit('app/SET_FIXED_STATUS', true);
    }
  },
  MODAL_CLOSE(state: State, key: string) {
    Vue.set(state.modal, key, false);

    let isEvery = Object.keys(state.modal).every((key) => !state.modal[key]);
    if (isEvery) {
      store.commit('app/SET_FIXED_STATUS', false);
    }
  },
  MODAL_SET_DATA(state: State, { key, data }: { key: string; data: any }) {
    Vue.set(state.modalData, key, data);
  },
  MODAL_RESET_DATA(state: State, key: string) {
    let value = typeof state.modalData[key] === 'object' ? {} : null;
    Vue.set(state.modalData, key, value);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
